import LuAgency from './LuAgency'
import TrackedBillDivision from './TrackedBillDivision'
export default class LuAgencyDivision {
  constructor(objIn = {}) {
    const defaults = {
      //Id is required
      Id: 0,
      //AgencyId is required
      AgencyId: 0,
      //Description is required
      Description: '',
      //IsActive is required
      IsActive: true,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.Id = obj.Id
    this.AgencyId = obj.AgencyId
    this.Description = obj.Description
    this.IsActive = obj.IsActive
    this.Agency = new LuAgency(obj.Agency || {})
    this.TrackedBillDivisions = []
    if (obj.TrackedBillDivisions) {
      obj.TrackedBillDivisions.forEach((item) => {
        this.TrackedBillDivisions.push(new TrackedBillDivision(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Agency = null
    obj.TrackedBillDivisions = []
    if (this.TrackedBillDivisions) {
      this.TrackedBillDivisions.forEach((item) => {
        obj.TrackedBillDivisions.push(
          item instanceof TrackedBillDivision ? item.removeRelated() : item
        )
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Agency = null
    obj.TrackedBillDivisions = null
    return obj
  }
}
